import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
    url: "https://auth.mistech.ru/",
    realm: "mist",
    clientId: "client",
});

// добавляем автоматическое перенаправление на аутентификацию при обращении к приложению
await keycloak.init({
    onLoad: 'login-required'
});

export default keycloak;